module.exports = __webpack_public_path__ + "img/footballfield3.ea229dd6.jpg";